define(function(require) {

	const rowView = require('civicsViews/log_links/v_itv_log_link');

	return Marionette.CollectionView.extend({
		config:{},
		tagName: 'ul',
		childView: rowView,
		className: 'log-links-list',
		template:'',
		ui:{
		},
		collectionEvents: {
		},
		initialize:function(options){
			this.config = options.config;
			this.editMode = options.editMode;
			this.canUpdateStatus = options.canUpdateStatus;
			this.isModal = options.isModal;
		},
		childViewOptions:function(model, index){
			return {
				config:this.config,
				modalRegion:this.options.modalRegion,
				instrumentType:this.options.instrumentType,
				instrumentID:this.options.instrumentID,
				canUpdateStatus: this.canUpdateStatus,
				isModal: this.isModal
			}
		}
	});
});
